<template name="parcel">
	<div class="support-box-child" >
		<!-- <div>社群拍档，让社群更温暖</div> -->
		
		<el-dialog width="567px" :title='op_id?"编辑物流信息":"添加物流信息"' :visible.sync="show_parcel" :before-close='close_dialog'  :close-on-click-modal='false'>
		  <el-form :model="form" style="padding-left: 20px;margin-top: 10px;">
		     <el-form-item label="物流单号" style="display: flex;">
		       <el-input style="width: 440px;" placeholder="填写快递单号" maxlength="32" v-model="ems_code" autocomplete="off"  @input="changeInput($event)"></el-input>
		     </el-form-item>
			<el-form-item label="物流公司" >
			  <el-select v-model="hundred_number" id="hundred_id" placeholder="默认同城配送" style="width: 440px;">
			     <el-option
			          v-for="item,ind in companys"
			          :key="item.hundred_number"
			          :label="item.name"
			          :value="item.hundred_number"
									>
			        </el-option>
			  </el-select>
			</el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="close_dialog">取 消</el-button>
		    <el-button type="primary" @click="add_express()">确 定</el-button>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	import {getExpressList,deliverGoods,matchingEms,getPackageInfo} from '../api/common';
	export default {
		data() {
			return {
				form:{},
				companys:{},
				hundred_number:'tc',//快递100的编号
				ems_code:'',//快递编号
			};
		},
		props: {
			show_parcel: {
				type: Boolean,
				value: false
			},
			order_sn:{
				type: String,
				value: ""
			},
			op_id:{
				type: Number,
				value: 0,
				default:0
			},
		},
		watch: {
			show_parcel: function(val, oldVal) {
				console.log(val);
			}
		},
		methods:{
			changeInput(value){
				var that = this;
				value = value.replace(/[^\w\.\/]/ig,'');
				this.ems_code = value;
				if (value.length > 8) {
					matchingEms({num: value}).then(res => {
						if(res.code == 0){
							var hundred_number = chooseExpress(res.info, that);
							that.hundred_number = hundred_number;
						}
					})
				}
			},
			getExpressList(){
				var that = this;
				//获取快递公司
				getExpressList().then(res => {
					if(res.code == 0){
						this.companys = res.data;
						if(this.op_id){
							that.getPackageInfo();
						}
					}
				})
				
			},
			getPackageInfo(){
				getPackageInfo(
					{
						op_id:this.op_id
					}
				).then(res => {
					if(res.code == 0){
						this.ems_code = res.data.ems_code;
						this.hundred_number = res.data.ems_id;
					}
				})
			},
			close_dialog(done) {
				console.log(123);
			        this.$emit('update:show_parcel', false); // 直接修改父组件的属性
			},
			add_express(){
				if(this.hundred_number != 'tc'){
					console.log(this.ems_code);
					if (!this.ems_code  || trim(this.ems_code).length < 1) {
							this.$message.error("请填写物流单号");
							return false;
					}
				}
				
				let obj = {};
				obj = this.companys.find((item) => {
				  return item.hundred_number === this.hundred_number;
				});
				console.log(obj);
				deliverGoods(
					{
						order_sn:this.order_sn,
						hundred_number:obj.hundred_number,
						express_name:obj.name,
						ems_code:this.ems_code,
						op_id:this.op_id
					}
				).then(res => {
					this.close_dialog();
					 if(res.code == 0){
						this.$message.success(res.message); 
					 }else{
						 this.$message.error(res.message);
					 }
					
				})
			}
		},
		mounted() {
			//获取快递公司
			this.getExpressList();
			
		}
	}
	　 function trim(str){ //删除左右两端的空格
	　　     return str.replace(/(^\s*)|(\s*$)/g, "");
	　　 }
	function chooseExpress(hundred_number = "", that) {
	  var list = that.companys;
	  for (var i in list) {
	    if (list[i]["hundred_number"] == hundred_number) {
	      return hundred_number;
	    }
	  }
	  return 'tc';
	}
</script>

<style>
.support-box-child{
	/* width: 424px; */
	height: 230px;
	margin: 0 auto;
}
.support-box-child image{
	width: 40px;
	height: 40px;
	display: block;
	margin-left: 4px;
}
.support-box-child .el-dialog__body{
	padding: 0;
	/* padding-left: 15px; */
}
</style>
